"use strict";

require("../scss/common.scss");

import $ from "jquery";

// This allows angular to find jQuery on the window
window.$ = $;
window.jQuery = $;

import angular from "angular";
import uiRouter from "@uirouter/angularjs";
import ngCookies from "angular-cookies";

import videogular from "videogular";
import videogularControlls from "videogular-controls";
import videogularBuffering from "videogular-buffering";
import videogularOverlayPlay from "videogular-overlay-play";
import videogularThemesDefault from "videogular-themes-default";

import angularUtilsPagination from "angular-utils-pagination";

import infiniteScroll from "ng-infinite-scroll";

import { core } from "site_core";

// Our Modules
import appRoutes from "./app.routes";
import appRun from "./app.run";
import appDirectives from "./app.directive.config.js";

("ngInject");
var app = angular.module("site", [
  angularUtilsPagination,
  uiRouter,
  ngCookies,
  core.components,
  core.features,
  core.factories,
  core.filters,
  videogular,
  videogularControlls,
  videogularBuffering,
  videogularOverlayPlay,
  infiniteScroll
]);

app.config(["$provide", appDirectives]);
app.config(appRoutes);
app.run(appRun);

app.constant("BASE_URLS", { API: API_URL, CONTENT: CONTENT_URL });

app.constant("siteConst", {
  id: 21,
  urlShort: "WorstBehaviorProductions.com",
  urlLong: "http://www.worstbehaviorproductions.com",
  urlMed: "www.worstbehaviorproductions.com",
  name: "Worst Behavior Productions",
  currentDate: Date.now(),
  footerTagline: "",
  logoLarge: "images/top_header.png",
  logoSmall: "images/top_header.png",
  warningBanner: "images/top_header.png",
  memberImage: "",
  twoTwoFiveSevenAddress: "5400 W. 64th Ave Arvada, CO 80007",
  webmasterEmail: "worstbehaviorproductions@spanking.support",
  metaDescription: "",
  tagline: {
    topLine: "WORST BEHAVIOR PRODUCTIONS",
    secondLine:
      "Welcome to WorstBehaviorProductions.com - Home of the Penalty Swats and Hot Spanking! Tons of sexy spanking featuring the hottest spanking models. Our hot models include Miss Lovecraft, Lady Alice, Veronica Weston, Stevie Rose, Riley Laroux, Apricot Pitts, Casey Calvert and much much more. Watch as large groups of young ladies get their bottoms smacked and paddled. F/F sensual spanking movies. Get Instant Access Today"
  },
  footerTagline: {
    bannerDetails: "",
    getPassword:
      '<div class="get_password"> <h4 ng-hide="$root.isMember"> <a href="/join">GET ACCESS NOW TO OUR EXCLUSIVE SPANKINGS VIDEOS!</a> </h4> <p>Home of the Penalty Swats and Hot Spanking! Sexy Woman and Sexy Spankings. Visit our <a href="https://www.clips4sale.com/studio/119500/cid364d5d3dcb6b487a0d422943f0" target="_blank">Clips4sale</a> and <a href="https://www.spankinglibrary.com/store/373" target="_blank">Spanking Library</a> store for more Exclusive Spanking Videos!</p></div>'
  },
  advert: {
    slider: {
      image: "images/ff_header.png"
    },
    tour: [
      "Welcome to Worst Behavior!",
      "Sexy F/F Spankings",
      "FF and MF Hard Spankings",
      "Huge Weekly Updates",
      "Unlimited Streaming and Downloads",
      "HD/SD Mobile and Tablet Ready"
    ],
    trailer: [
      "Sensual F/F Spankings",
      "FF and MF Hard Spankings",
      "Huge Weekly Updates",
      "Unlimited Streaming and Downloads",
      "HD/SD Mobile and Tablet Ready",
      "Group Spanking Movies",
      "Hot Young Spanking Models"
    ]
  },
  tour: {
    updates: 12,
    comingSoon: 3,
    models: 24
  },
  join: {
    ccbill: {
      key: "9ccbaa8c-4e6e-49dd-818a-f2334cbbbf0e"
    },
    cco: {
      accountId: 9309,
      siteId: 23695,
      products: [
        {
          price: 79.95,
          text:
            '<div class="details"> <div class="duration">6 Months Access</div> <div class="description">Only 79.95 for 6 months *** No Rebills ***</div> </div> <div class="discount">Save 125%!</div> <div class="price">$13.33 / month</div>',
          productId: 42130
        },
        {
          price: 59.95,
          text:
            '<div class="details"> <div class="duration">3 Months Access</div> <div class="description">Only 59.95 for 3 months</div> </div> <div class="discount">Save 50%!</div> <div class="price">$19.98 / month</div>',
          productId: 42130
        },
        {
          price: 29.95,
          text:
            '<div class="details"> <div class="duration">30 Day Access</div> <div class="description">Only 29.95 for 30 days</div> </div> <div class="discount">Save 0%!</div> <div class="price">$0.99 / day</div>',
          productId: 42130
        }
      ]
    }
  },
  members: {
    video: {
      labels: true
    },
    images: {
      showImages: true
    }
  }
});



// WEBPACK FOOTER //
// ./src/app/app.js